import React from 'react';
import {Avatar, SvgIcon} from "@mui/material";
import User01Icon from "@untitled-ui/icons-react/build/esm/User01";
import {getInitials} from "src/PWM/utils/get-initials";
import {useAuth} from "src/PWM/hooks/use-auth";

const PWMUserAvatar: React.FC<IPWMUserAvatarProps> = (props) => {
  const {account} = useAuth();
  return (
    <Avatar
      sx={{height: 32, width: 32}}
      src={account?.photo}
    >
      {account?.name ? getInitials(account?.name) : (
        <SvgIcon fontSize="small">
          <User01Icon/>
        </SvgIcon>)}
    </Avatar>
  )
};

export default PWMUserAvatar;

interface IPWMUserAvatarProps {
  children?: React.ReactNode
}